import {Endpoint, EndpointAddress} from './KubernetesClient.ts';

export interface KubernetesApiProvider {
    getEndpointsByNameUrlString(kubernetesMaster: string, namespace: string, endpointName: string): string;

    getEndpointsByServiceLabelUrlString(kubernetesMaster: string, namespace: string, serviceLabel: string): string;

    parseEndpoints(param: any): Endpoint[];
}

export class KubernetesApiEndpointSlicesProvider implements KubernetesApiProvider {
    getEndpointsByServiceLabelUrlString(kubernetesMaster: string, namespace: string, param: string): string {
        return `${kubernetesMaster}/apis/discovery.k8s.io/v1/namespaces/${namespace}/endpointslices?${param}`;
    }

    getEndpointsByNameUrlString(kubernetesMaster: string, namespace: string, endpointName: string): string {
        return `${kubernetesMaster}/apis/discovery.k8s.io/v1/namespaces/${namespace}/endpointslices?labelSelector=kubernetes.io/service-name=${endpointName}`;
    }

    parseEndpoints(param: {
        items: Array<{ endpoints: Array<{ conditions: { ready: boolean }, addresses: Array<string> }>, ports: Array<{}> }>
    }): Endpoint[] {
        const endpoints = new Array<Endpoint>();
        for (const item of param.items) {
            endpoints.push(...this.parseEndpointSlices(item));
        }
        return endpoints;
    }

    private parseEndpointSlices(item: {
        endpoints: Array<{
            conditions: {
                ready: boolean
            },
            addresses: Array<string>
        }>,
        ports: Array<{name?: string, port?: number}>
    }): Endpoint[] {
        const addresses = new Array<Endpoint>();
        const endpointPort = this.extractPort(item);
        for (const endpoint of item.endpoints) {
            const ready = endpoint.conditions.ready;
            for (const address of endpoint.addresses) {
                addresses.push(new Endpoint(new EndpointAddress({ip: address, port: endpointPort}), undefined, ready))
            }

        }
        return addresses;
    }

    private extractPort(item: {
        ports: Array<{
            name?: string,
            port?: number

        }>
    }): number | undefined {
        for (const port of item.ports) {
            const bridgeServicePort = port.name;
            if (bridgeServicePort && bridgeServicePort === 'io-bridge') {
                const servicePort = port.port;
                if (servicePort !== undefined) {
                    return servicePort;
                }
            }
        }
        if (item.ports.length === 1) {
            const port = item.ports[0];
            const servicePort = port.port;
            if (servicePort !== undefined) {
                return servicePort;
            }
        }
    }
}
